"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloneBatchStatusBadge = CloneBatchStatusBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var table_1 = require("../../table");
function CloneBatchStatusBadge(props) {
    var _a;
    var status = props.status;
    var STATUS_COLORS = {
        ROOTING: "amber",
        AVAILABLE: "green-soft",
        FULLY_ALLOCATED: "blue",
    };
    if (!status) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(table_1.StatusBadge, { color: (_a = STATUS_COLORS[status]) !== null && _a !== void 0 ? _a : "navy", children: status });
}
